import { render } from "./MediateList.vue?vue&type=template&id=3e08ab55&scoped=true&ts=true"
import script from "./MediateList.vue?vue&type=script&lang=ts"
export * from "./MediateList.vue?vue&type=script&lang=ts"

import "./MediateList.vue?vue&type=style&index=0&id=3e08ab55&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e08ab55"]])

export default __exports__